/**
 * Client-side accessor for the Standaard winkel beheer-pagina.
 *
 * Wraps `getStandardStorePageDataFn` in a `queryOptions` factory so the
 * route loader can pre-fetch via `ensureQueryData` and the form can
 * consume via `useSuspenseQuery` against guaranteed data. Returns the
 * baseline together with the active configuration's bandwidth codes
 * (for row labels + ordering + color swatches) and the size buckets
 * (for the derived Store Size label).
 */
import { queryOptions } from "@tanstack/react-query"
import { getStandardStorePageDataFn } from "@/features/standard-store/server/standardStoreServer"
import { standardStoreQueryKeys } from "@/lib/queryKeys"

export const standardStorePageQuery = () =>
  queryOptions({
    queryKey: standardStoreQueryKeys.baseline(),
    queryFn: () => getStandardStorePageDataFn(),
    // Baseline changes ~1× per 2 years — generous cache. The bandwidths
    // + buckets are also bundled, so the cache stays warm across the
    // form's edit/save cycle as long as we invalidate on save.
    staleTime: 5 * 60 * 1000,
  })
